import { Badge } from "@/components/ui/Badge";
import { ALL_ELEMENTS } from "@/data";
import { selectActiveForce, useForceStore } from "@/store/forceStore";
import type { FactionId, TrainingTier } from "@/types/game-data";

/** Returns the default (cheapest / most common) tier for a given faction */
function getDefaultTier(faction: FactionId): TrainingTier {
	switch (faction) {
		case "militia":
			return "militia";
		case "taskforce":
			return "tier2";
		case "russian":
			return "enlisted";
		case "law-enforcement":
			return "enlisted";
		case "criminal-element":
			return "criminal";
	}
}

export function ElementBrowser() {
	const force = useForceStore(selectActiveForce);
	const addElement = useForceStore((s) => s.addElement);

	if (!force) return null;

	const faction = force.faction;

	const elements = ALL_ELEMENTS.filter((e) => e.faction === faction);

	function handleAdd(templateId: string) {
		const template = elements.find((e) => e.id === templateId);
		const defaultTier = template?.allowedTiers[0] ?? getDefaultTier(faction);
		addElement(templateId, defaultTier);
	}

	return (
		<div className="space-y-2">
			<h3 className="text-xs font-semibold text-text-muted uppercase tracking-wider px-1">
				Add Element
			</h3>
			<div className="flex flex-col gap-1.5">
				{elements.map((el) => (
					<button
						key={el.id}
						type="button"
						onClick={() => handleAdd(el.id)}
						className="text-left px-3 py-2.5 rounded-md text-sm transition-all cursor-pointer text-text-secondary hover:bg-bg-tertiary border border-transparent hover:border-border-default group"
					>
						<div className="flex items-center justify-between">
							<span className="font-medium group-hover:text-text-primary">{el.name}</span>
							<Badge variant="green" size="sm">
								{el.baseCost != null ? `${el.baseCost}r` : "+ Add"}
							</Badge>
						</div>
						<div className="text-xs text-text-muted mt-0.5">
							{el.minModels === el.maxModels ? el.minModels : `${el.minModels}-${el.maxModels}`}{" "}
							models
							{el.hasCommander && " (incl. Commander)"}
							{el.additionalModelCost
								? ` · +${el.additionalModelCost}r per extra`
								: ""}
						</div>
					</button>
				))}
			</div>
		</div>
	);
}
